import styled from "styled-components";

export const AddContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
